<template>
  <el-select
      ref="select"
      filterable
      :placeholder=placeholder
      v-model="newValue"

      :disabled="disabled == null? false:disabled"
      clearable
  >
    <el-option
        v-for="item in list"
        :label="item[labelname]"
        :value="item[labelname]"
        @click="change(item)"
    ></el-option>
  </el-select>
</template>
<script>
import {commonGet} from "@/request"
export default {
  name: "single select",

  data(){
    return{
      list:[],
      newValue: undefined,
      nameValue:'name',
      idValue:'id',
      labelname:'Name'
    }
  },
  props:[
      'url',
      'model',
      'placeholder',
      'param',
      'Name',
      'Id',
      'disabled',
      'label'
  ],
  created() {
    if(this.label){
      this.labelname = this.label
    }else{
      this.labelname = this.Name
    }
    if(this.Name != undefined){
      this.nameValue = this.Name
    }
    if(this.Id != undefined){
      this.idValue = this.Id
    }
    commonGet(this.url).then(res=>{
      this.list = res.data
    })
    this.newValue = this.model
  },
  mounted() {
    this.newValue = this.model
  },
  methods:{
    change(item){
      let name = this.Name
      let id = this.Id
      this.$emit('id',item[id])
      this.$emit('name',item[name])
      this.$emit('event',item)
    },
    reset(){
      console.log(this.$refs['select'])
      this.newValue = undefined
    },
  },
  watch:{
    'model'(e){
      this.newValue = e
    }
  }

}
</script>

<style scoped>

</style>
